/*
 * Public API Surface of the rule based configurator
 */

export * from './index';

/** AUGMENTABLE_TYPES_START */
export { Configurator } from './core/model/configurator.model';
/** AUGMENTABLE_TYPES_END */
